/** Read the loaded document, never the latest deployment from a remote endpoint. */
export function readSiteVersion(doc: Document = document): string | undefined {
  const values = [
    ...Array.from(doc.querySelectorAll('meta[name="kiwiloop:site-version"], meta[name="grundion:site-version"]'))
      .map(el => el.getAttribute('content')),
    doc.documentElement.getAttribute('data-site-version'),
    ...Array.from(doc.querySelectorAll('script[data-kiwiloop-site-feedback][data-site-version], script[src*="/site-feedback/v1.js"][data-site-version]'))
      .map(el => el.getAttribute('data-site-version')),
  ].filter((value): value is string => value !== null && value !== '')
  if (!values.length || values.some(value => !/^[A-Za-z0-9][A-Za-z0-9._:+@-]{0,127}(?![\s\S])/.test(value))) return undefined
  return new Set(values).size === 1 ? values[0] : undefined
}
